import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { AvatarService } from '../services/avatar.service';

@Component({
  selector: 'app-avatar-simple',
  templateUrl: './avatar-simple.component.html',
  styleUrls: ['../avatar.component.scss', './avatar-simple.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarSimpleComponent implements OnChanges {
  @Input() userId: number;
  @Input() userName = '';
  @Input() containerCss = '';
  @Input() showName = true;

  avatarTheme = 'default';
  initials = '??';
  firstName = '';
  lastName = '';

  constructor(private avatarService: AvatarService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.userId) {
      return;
    }
    this.avatarTheme = this.avatarService.getUserConfig(this.userId);
    this.initials = this.userName
      ? this.userName
          .split(' ')
          .map(name => name[0]?.toUpperCase())
          .slice(0, 2)
          .join('')
      : '??';
    const splittedName = this.userName?.split(' ');
    if (!splittedName) return;
    this.firstName = splittedName[0] || '';
    this.lastName = splittedName[1] || '';
    this.lastName = this.lastName ? this.lastName[0] : '';
  }
}
